import React from 'react';
export function PhasesSection() {
  return <section className="py-20 px-5 bg-cream-dark text-center reveal" data-id="element-173">
      <h2 className="font-playfair text-[clamp(1.8rem,3.5vw,2.6rem)] font-bold text-text-dark mb-3.5 leading-[1.2]" data-id="element-174">
        Cómo funciona el sistema
      </h2>
      <p className="font-lora text-base text-text-mid max-w-[500px] mx-auto mb-10 leading-relaxed italic" data-id="element-175">
        Un proceso natural, lógico y sin estrés.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[780px] mx-auto" data-id="element-176">
        {/* Phase 1 */}
        <div className="bg-white rounded-xl py-8 px-6 text-center shadow-[0_2px_16px_rgba(30,45,36,0.06)] transition-transform duration-200 hover:-translate-y-1 relative" data-id="element-177">
          <div className="text-[2rem] mb-3.5" data-id="element-178">👂</div>
          <div className="text-[0.7rem] tracking-[0.12em] uppercase text-text-light mb-1.5 font-medium" data-id="element-179">
            Fase 1
          </div>
          <div className="font-playfair text-[1.15rem] font-bold text-text-dark mb-2.5" data-id="element-180">
            Reconoce el sonido
          </div>
          <p className="text-[0.85rem] text-text-mid leading-[1.6]" data-id="element-181">
            Antes de leer letras, el niño aprende a identificar los sonidos del
            habla. Sin letras. Solo oído.
          </p>
          <div className="mt-3.5 text-[0.82rem] text-forest font-medium italic font-lora" data-id="element-182">
            → Tu hijo quiere jugar con los sonidos.
          </div>
        </div>

        {/* Phase 2 (Featured) */}
        <div className="bg-white rounded-xl py-8 px-6 text-center shadow-[0_2px_16px_rgba(30,45,36,0.06)] transition-transform duration-200 border-2 border-forest scale-105 hover:-translate-y-1 relative" data-id="element-183">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-forest text-cream text-[0.65rem] tracking-[0.1em] uppercase py-1 px-3 rounded-full font-semibold" data-id="element-184">
            CLAVE
          </div>
          <div className="text-[2rem] mb-3.5" data-id="element-185">🔤</div>
          <div className="text-[0.7rem] tracking-[0.12em] uppercase text-text-light mb-1.5 font-medium" data-id="element-186">
            Fase 2
          </div>
          <div className="font-playfair text-[1.15rem] font-bold text-text-dark mb-2.5" data-id="element-187">
            Une sonido y letra
          </div>
          <p className="text-[0.85rem] text-text-mid leading-[1.6]" data-id="element-188">
            Conectamos ese sonido familiar con su símbolo gráfico. El "click"
            mental ocurre aquí.
          </p>
          <div className="mt-3.5 text-[0.82rem] text-forest font-medium italic font-lora" data-id="element-189">
            → Empieza a reconocer letras sin presión.
          </div>
        </div>

        {/* Phase 3 */}
        <div className="bg-white rounded-xl py-8 px-6 text-center shadow-[0_2px_16px_rgba(30,45,36,0.06)] transition-transform duration-200 hover:-translate-y-1 relative" data-id="element-190">
          <div className="text-[2rem] mb-3.5" data-id="element-191">📖</div>
          <div className="text-[0.7rem] tracking-[0.12em] uppercase text-text-light mb-1.5 font-medium" data-id="element-192">
            Fase 3
          </div>
          <div className="font-playfair text-[1.15rem] font-bold text-text-dark mb-2.5" data-id="element-193">
            Forma su primera palabra
          </div>
          <p className="text-[0.85rem] text-text-mid leading-[1.6]" data-id="element-194">
            Juntamos sonidos para crear significado. La lectura nace de la
            comprensión, no de la repetición.
          </p>
          <div className="mt-3.5 text-[0.82rem] text-forest font-medium italic font-lora" data-id="element-195">
            → Lee y se siente capaz. Cambio de actitud real.
          </div>
        </div>
      </div>
    </section>;
}